module.exports = __webpack_public_path__ + "img/17_71.8cddc577.png";